module.exports = __webpack_public_path__ + "static/1_survival-223ddd0e942cea58a6f0810a2c2ce25e.png";